<template>
    <div>

    </div>
</template>

<script>
    import TransportService from "@/services/TransportService";


    export default{
        name: "PrintManifestComponent",
        props: {
            manifestId: {
                type: Number,
                required: true
            }
        },
        data(){
            return{
            }
        },
        methods: {
            printManifest(){
                if(this.$props.manifestId != 0 && this.$props.manifestId != null){
                    let param = {id: this.$props.manifestId};
                    TransportService.downloadFile("/manifestFile/print", param)
                        .then((res) => {
                            if(res.type === 'application/pdf' && res != null){
                                let blob = new Blob([res], { type: 'application/pdf' })
                                let objectUrl = window.URL.createObjectURL(blob)
                                window.open(objectUrl)
                            } else {
                                this.$messager.alert({
                                            title: "Error",
                                            icon: "error",
                                            msg: res.message
                                        });
                            }
                        }).catch((error) => {
                            this.$refs.notification.error(error);
                        });
                }
            }
        },
    }
</script>